import { __extends } from "tslib";
import React from "react";
import * as dateFns from "date-fns";
var Calendar = /** @class */ (function (_super) {
    __extends(Calendar, _super);
    function Calendar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentMonth: _this.props.defaultDate || new Date(),
            selectedDate: _this.props.defaultDate || new Date()
        };
        _this.onDateClick = function (day) {
            _this.setState({
                selectedDate: day
            }, function () {
                if (_this.props.dateClick) {
                    _this.props.dateClick(day);
                }
            });
        };
        _this.nextMonth = function () {
            _this.setState({
                currentMonth: dateFns.addMonths(_this.state.currentMonth, 1)
            });
        };
        _this.prevMonth = function () {
            _this.setState({
                currentMonth: dateFns.subMonths(_this.state.currentMonth, 1)
            });
        };
        return _this;
    }
    Calendar.prototype.renderHeader = function () {
        var dateFormat = "MMMM yyyy";
        return (React.createElement("div", { className: "calendar__header row flex-middle" },
            React.createElement("div", { className: "col col-start" },
                React.createElement("div", { className: "icon", onClick: this.prevMonth }, "chevron_left")),
            React.createElement("div", { className: "col col-center" },
                React.createElement("span", null, dateFns.format(this.state.currentMonth, dateFormat))),
            React.createElement("div", { className: "col col-end", onClick: this.nextMonth },
                React.createElement("div", { className: "icon" }, "chevron_right"))));
    };
    Calendar.prototype.renderDays = function () {
        var dateFormat = "EEE";
        var days = [];
        var startDate = dateFns.startOfWeek(this.state.currentMonth, { weekStartsOn: 1 });
        for (var i = 0; i < 7; i++) {
            days.push(React.createElement("div", { className: "col col-center", key: i }, dateFns.format(dateFns.addDays(startDate, i), dateFormat)));
        }
        return React.createElement("div", { className: "days row" }, days);
    };
    Calendar.prototype.renderCells = function () {
        var _this = this;
        var _a = this.state, currentMonth = _a.currentMonth, selectedDate = _a.selectedDate;
        var monthStart = dateFns.startOfMonth(currentMonth);
        var monthEnd = dateFns.endOfMonth(monthStart);
        var startDate = dateFns.startOfWeek(monthStart, { weekStartsOn: 1 });
        var endDate = dateFns.endOfWeek(monthEnd, { weekStartsOn: 1 });
        var dateFormat = "d";
        var rows = [];
        var days = [];
        var day = startDate;
        var formattedDate = "";
        var notBefore = this.props.startDate || new Date();
        if (dateFns.isBefore(notBefore, new Date())) {
            notBefore = new Date();
        }
        while (day <= endDate) {
            var _loop_1 = function (i) {
                formattedDate = dateFns.format(day, dateFormat);
                var cloneDay = day;
                days.push(React.createElement("div", { className: "col cell ".concat(!dateFns.isSameMonth(day, monthStart)
                        || (dateFns.isAfter(notBefore, day) && !dateFns.isSameDay(notBefore, day))
                        ? "disabled"
                        : dateFns.isSameDay(day, selectedDate) ? "selected" : ""), key: day.toDateString(), onClick: function () { return _this.onDateClick(cloneDay); } },
                    React.createElement("span", { className: "number" }, formattedDate),
                    React.createElement("span", { className: "bg" }, formattedDate),
                    dateFns.isSameDay(day, selectedDate) && this_1.props.selectedText ?
                        React.createElement("span", { className: "selected-text" }, this_1.props.selectedText)
                        : null));
                day = dateFns.addDays(day, 1);
            };
            var this_1 = this;
            for (var i = 0; i < 7; i++) {
                _loop_1(i);
            }
            rows.push(React.createElement("div", { className: "row", key: day.toDateString() }, days));
            days = [];
        }
        return React.createElement("div", { className: "body" }, rows);
    };
    Calendar.prototype.render = function () {
        return (React.createElement("div", { className: "calendar" },
            this.renderHeader(),
            this.renderDays(),
            this.renderCells()));
    };
    return Calendar;
}(React.Component));
export { Calendar };
//# sourceMappingURL=Calendar.js.map